module.exports = __webpack_public_path__ + "static/media/icon-circular-x-white.ddaa0175.svg";